import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectShared = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M27.5 5H16.11L5 20l7.5 23H29v-3H15l-3.191-9.574 22.834-9.766 2.28 3.34h3.666zm-13.665 8.09L17.5 8H26l6.92 10.134-9.95 4.256zM8.5 20.5l3.556-4.939 7.952 8.095-9.151 3.914z" }), /* @__PURE__ */ _jsx("path", { d: "M39.996 34.3q1.504 0 2.579-1.071t1.075-2.575-1.071-2.579T40.004 27t-2.579 1.071q-1.075 1.07-1.075 2.575 0 1.504 1.071 2.579t2.575 1.075M32 42.05V43h16v-.95q0-2.1-2.125-3.425T40 37.3t-5.875 1.325T32 42.05" })]
});
export default SvgProjectShared;
